import "konva-node";
import { useMemo } from "react";
import { getShapeProps, getKonvaElement, CANVAS_FULL_WIDTH, SSR_CANVAS_FULL_HEIGHT } from "./helpers";

const getCanvasData = (shapeSegments) => {
  let stage;

  try {
    stage = new Konva.Stage({
      width: CANVAS_FULL_WIDTH,
      height: SSR_CANVAS_FULL_HEIGHT
    });

    const layer = new Konva.Layer();
    stage.add(layer);

    shapeSegments.forEach((ss) => {
      if (!ss.props.relativeTo) {
        const shapeProps = getShapeProps(ss.props, ss.type);
        const konvaElement = getKonvaElement(ss.type);
        const box = new konvaElement(shapeProps);
        layer.add(box);
      }
    });

    layer.draw();

    return stage.toDataURL();
  } catch (e) {
    return "";
  } finally {
    if (stage) {
      stage.destroy();
      stage = null;
    }
  }
};

const SsrCanvas = (props) => {
  const { shapeSegments } = props;

  const data = getCanvasData(shapeSegments);

  return <img src={data} alt="" />;
};

export default SsrCanvas;
